import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../assets/page-image/trzfw/banner.png';
const _hoisted_1 = {
  class: "trzfw-wrapper"
};
const _hoisted_2 = {
  class: "trzfw-page"
};
const _hoisted_3 = {
  key: 0,
  class: "section"
};
const _hoisted_4 = {
  class: "fund-container"
};
const _hoisted_5 = {
  class: "card-logo"
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = {
  class: "card-title"
};
const _hoisted_8 = {
  class: "card-content"
};
const _hoisted_9 = {
  key: 1,
  class: "section"
};
const _hoisted_10 = {
  class: "fund-container"
};
const _hoisted_11 = {
  class: "card-logo"
};
const _hoisted_12 = ["src", "alt"];
const _hoisted_13 = {
  class: "card-title"
};
const _hoisted_14 = {
  class: "card-content"
};
const _hoisted_15 = {
  key: 2,
  class: "section"
};
const _hoisted_16 = {
  class: "fund-container"
};
const _hoisted_17 = {
  class: "fund-cards-row"
};
const _hoisted_18 = {
  class: "card-logo"
};
const _hoisted_19 = ["src", "alt"];
const _hoisted_20 = {
  class: "card-title"
};
const _hoisted_21 = {
  class: "card-content"
};
import { ref, onMounted } from 'vue';
import SectionTitle from '@/components/SectionTitle.vue';
import Footer from '@/components/Footer.vue';
import { getFinancingInfo } from '@/api/financing';
// 投融资服务信息数据
export default /*@__PURE__*/_defineComponent({
  __name: 'Trzfw',
  setup(__props) {
    const financingInfo = ref({});
    // 获取投融资服务信息
    const fetchFinancingInfo = async () => {
      try {
        const res = await getFinancingInfo();
        if (res.code === 200) {
          financingInfo.value = res.data;
          // console.log('投融资服务信息:', financingInfo.value);
        }
      } catch (error) {
        console.error('获取投融资服务信息失败:', error);
      }
    };
    // 页面加载时获取数据
    onMounted(() => {
      fetchFinancingInfo();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "投融资服务"
      })])], -1)), _createElementVNode("div", _hoisted_2, [financingInfo.value['self-owned'] && financingInfo.value['self-owned'].length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(SectionTitle, {
        title: "自有基金",
        "show-more": false
      }), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(financingInfo.value['self-owned'], item => {
        return _openBlock(), _createElementBlock("div", {
          class: "fund-card large",
          key: item.id
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          src: item.url,
          alt: item.name
        }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.description), 1)]);
      }), 128))])])) : _createCommentVNode("", true), financingInfo.value['self-incubation'] && financingInfo.value['self-incubation'].length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(SectionTitle, {
        title: "自有孵化基金",
        "show-more": false
      }), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(financingInfo.value['self-incubation'], item => {
        return _openBlock(), _createElementBlock("div", {
          class: "fund-card large",
          key: item.id
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
          src: item.url,
          alt: item.name
        }, null, 8, _hoisted_12)]), _createElementVNode("div", _hoisted_13, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(item.description), 1)]);
      }), 128))])])) : _createCommentVNode("", true), financingInfo.value['cooperative-investment'] && financingInfo.value['cooperative-investment'].length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(SectionTitle, {
        title: "合作投资基金",
        "show-more": false
      }), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(financingInfo.value['cooperative-investment'], item => {
        return _openBlock(), _createElementBlock("div", {
          class: "fund-card medium",
          key: item.id
        }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
          src: item.url,
          alt: item.name
        }, null, 8, _hoisted_19)]), _createElementVNode("div", _hoisted_20, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(item.description), 1)]);
      }), 128))])])])) : _createCommentVNode("", true)]), _createVNode(Footer)]);
    };
  }
});